import React from 'react'

import { Disclosure } from '@cred/react-disclosures-sdk'

const noOffersDisclaimers = {
  ups: <Disclosure required={false} slug="personal.generic.upstart" />,
  'universal-credit': <Disclosure required={false} slug="personal.generic.universal" />,
  upgrade: <Disclosure required={false} slug="personal.generic.upgrade" />,
}

export default noOffersDisclaimers
